export const CREATE_POKEMON="CREATE_POKEMON"
export const FIND_POKEMON="FIND_POKEMON"
export const FIND_POKEMONS_BY_ID="FIND_POKEMONS_BY_ID"
export const FIND_POKEMONS_BY_NAME="FIND_POKEMONS_BY_NAME"
export const CLEAR_POKEMON="CLEAR_POKEMON"